export enum COLORS {
  NEUTRAL = '#DBDBD9',
  PRIMARY = '#fe0060',
  SECONDARY = '#ff624a',
  TERTIARY = '#ffa23f',
  PRIMARY_TEXT = '#202020',
  SECONDARY_TEXT = '#FFF',
}
